// extracted by mini-css-extract-plugin
export default {"imgBtb":"ImageButton_imgBtb__CoulC"};